import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TopSkill } from '@freelancer/datastore/collections';
import { Feature } from '@freelancer/feature-flags';
import { LinkColor, LinkHoverColor } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { FontType } from '@freelancer/ui/text';
import { TooltipPosition } from '@freelancer/ui/tooltip';

@Component({
  selector: 'app-user-profile-skills-item',
  template: `
    <fl-bit class="UserProfileSkill">
      <fl-bit *flFeature="Feature.DEPRECATED_SEARCH_PAGES; else linkless">
        <fl-tooltip
          *ngIf="skill.certified"
          i18n-message="
            User Profile Skill Completed All Skill Name Exams Message
          "
          message="Completed all  {{ skill.name }} exams"
          [position]="TooltipPosition.BOTTOM_CENTER"
          [flMarginRight]="Margin.XXSMALL"
        >
          <fl-icon [name]="'ui-reward-medal'"></fl-icon>
        </fl-tooltip>
        <fl-link
          class="UserProfileSkill-skillName"
          flTrackingLabel="UserProfileSkillsItemClick"
          [link]="'/freelancers/skills/' + skill.seoUrl"
          [hoverColor]="LinkHoverColor.INHERIT"
          [color]="LinkColor.INHERIT"
        >
          {{ skill.name }}
        </fl-link>
      </fl-bit>
      <ng-template #linkless>
        <fl-text class="UserProfileSkill-skillName" [fontType]="FontType.SPAN">
          {{ skill.name }}
        </fl-text>
      </ng-template>
      <fl-tooltip
        i18n-message="User Profile Skill Skill Name Project Completed Message"
        message="{{ skill.name }} projects completed"
        [position]="TooltipPosition.BOTTOM_CENTER"
      >
        <fl-text *ngIf="skill.usages > 0" [fontType]="FontType.SPAN">
          {{ skill.usages }}
        </fl-text>
      </fl-tooltip>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-skills-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileSkillsItemComponent {
  Feature = Feature;
  LinkHoverColor = LinkHoverColor;
  FontType = FontType;
  LinkColor = LinkColor;
  Margin = Margin;
  TooltipPosition = TooltipPosition;

  @Input() skill: TopSkill;
}
